import { Injectable } from '@angular/core';
import {HttpService} from '../http.service';
import {Observable, of, throwError} from 'rxjs';
import {catchError, switchMap} from 'rxjs/operators';

import {AbstractRestService} from '../../shared/types/AbstractRestService';
import {PhoneVerificationReqRes} from '../../shared/components/phone-verification-dialog/PhoneVerificationReqRes.model';
import {PhoneVerificationReq} from '../../shared/components/phone-verification-dialog/PhoneVerificationReq.model';
import {SearchOptionsResponse} from '../../shared/models/SearchOptionsResponse.model';
import {AppSettingsService} from '../app-settings.service';
import { PaymentCreateDto } from 'src/app/shared/components/unit/unit-payment/models/payment/payment-create-dto.model';
import { PaymentReadDto } from 'src/app/shared/components/unit/unit-payment/models/payment/payment-read-dto.model';
import { PaymentSearchOptionsDto } from 'src/app/shared/components/unit/unit-payment/unit-recipient-payments-history/paymentSearchOptionsDto.model';
import { PaymentListItemReadDto } from 'src/app/shared/components/unit/unit-payment/models/payment/payment-list-item-read-dto.model';

@Injectable({
  providedIn: 'root'
})
export class UnitPaymentsDataService extends AbstractRestService<PaymentReadDto, PaymentReadDto>{
  protected readonly baseEndpoint$ = this.appSettingsService.localEnv ?
                                     of('https://localhost:44360/api/payments/') :
                                     of('payments/');


  constructor(public http: HttpService,
              private appSettingsService: AppSettingsService) {
    super(http);
  }

  protected getSearchOptionsToQuerystring(options: PaymentSearchOptionsDto): string {
    let queryString = super.getSearchOptionsToQuerystring(options);
    if (options.category) {
      queryString = queryString + `&category=${options.category}`;
    }

    if (options.fromDate && options.toDate) {
      queryString = queryString + `&fromDate=${options.fromDate}&toDate=${options.toDate}`;
    }

    if (options.recipientId) {
      queryString = queryString + `&recipientId=${options.recipientId}`;
    }

    return queryString;
  }

  public initPayment(model: PaymentCreateDto): Observable<PaymentReadDto> {
    return this.baseEndpoint$.pipe(
      switchMap(baseUrl => this.http.postTyped<PaymentReadDto>(baseUrl, model)),
      catchError(err => {
        return throwError(err);
      })
    );
  }

  public sendOtp(paymentId: number): Observable<PhoneVerificationReqRes> {
    return this.baseEndpoint$.pipe(
      switchMap(baseUrl => this.http.getTyped<PhoneVerificationReqRes>(`${baseUrl}${paymentId}/send-otp`)),
      catchError(err => {
        return throwError(err);
      })
    );
  }

  public verifyPhone(paymentId: number, model: PhoneVerificationReq): Observable<PhoneVerificationReqRes> {
    return this.baseEndpoint$.pipe(
      switchMap(baseUrl => this.http.postTyped<PhoneVerificationReqRes>(`${baseUrl}${paymentId}/verify`, model)),
      catchError(err => {
        return throwError(err);
      })
    );
  }

  public updatePaymentDetails(paymentId: number, model: PaymentCreateDto): Observable<PaymentReadDto> {
    return this.baseEndpoint$.pipe(
      switchMap(baseUrl => this.http.putTyped<PaymentReadDto>(`${baseUrl}${paymentId}`, model)),
      catchError(err => {
        return throwError(err);
      })
    );
  }

  public confirmPayment(paymentId: number) {
    return this.baseEndpoint$.pipe(
      switchMap(baseUrl => this.http.putTyped<PaymentReadDto>(`${baseUrl}${paymentId}/pay`)),
      catchError(err => {
        return throwError(err);
      })
    );
  }

  public paymentsHistory(searchOptions: PaymentSearchOptionsDto) {
    const queryString = searchOptions ? this.getSearchOptionsToQuerystring(searchOptions) : '';
    return this.baseEndpoint$.pipe(
      switchMap(baseUrl => this.http.getTyped<SearchOptionsResponse<PaymentListItemReadDto>>(`${baseUrl}history${queryString}`)),
      catchError(err => {
        return throwError(err);
      })
    );
  }


}
